import { createAction } from 'typesafe-actions';
import { SettingPanels } from 'widgets/Settings/types';
import { ACTIONS } from './types';

export const manageSettingsPanelAction = createAction(ACTIONS.MANAGE_SETTINGS_PANEL)<{
  settingsPanel: SettingPanels | null;
  hasClickJackpotSlot?: boolean;
  hasClickPreviewChat?: boolean;
}>();
